import { StateCreator } from "zustand";
import { supabase } from "@/lib/supabase";
import { Logger } from "@/lib/logger/Logger";
import { showNotification } from "./selectors";
import { SupabaseWriteTableEnum } from "@/lib/supabase/supabaseTypes";
import { CentralSlice } from "./central.store";
import { ClientSlice } from "./client.store";

export interface CatalogsSlice {
	setDefaultCatalog: (catalogId: string | null, catalogType: 'default' | 'custom') => Promise<void>;
	setClientDefaultCatalog: (catalogId: string | null, catalogType: 'default' | 'custom') => Promise<void>;
}

export const createCatalogsSlice: StateCreator<
	CentralSlice & ClientSlice & CatalogsSlice,
	[],
	[],
	CatalogsSlice
> = (set, get) => ({
	setDefaultCatalog: async (catalogId: string | null, catalogType: 'default' | 'custom') => {
		const { organization } = get();

		if (!organization?.id) {
			Logger.error("No organization ID when setting default catalog");
			return;
		}

		try {
			const updateData: any = {};

			if (catalogId === null) {
				updateData.default_catalogs_default_id = null;
				updateData.default_catalogs_custom_id = null;
			} else if (catalogType === 'default') {
				updateData.default_catalogs_default_id = catalogId;
				updateData.default_catalogs_custom_id = null;
			} else {
				updateData.default_catalogs_default_id = null;
				updateData.default_catalogs_custom_id = catalogId;
			}

			const { error } = await supabase
				.from(SupabaseWriteTableEnum.ORGANIZATIONS)
				.update(updateData)
				.eq("id", organization.id);

			if (error) {
				Logger.error("Error setting default catalog: " + error.message);
				showNotification({
					message: "Fehler beim Setzen des Standard-Katalogs",
					type: "error",
				});
				return;
			}

			set({
				organization: {
					...organization,
					...updateData
				} as any
			});

			showNotification({
				message: catalogId ? "Standard-Katalog erfolgreich gesetzt" : "Standard-Katalog entfernt",
				type: "success",
			});
		} catch (error) {
			Logger.error("Error setting default catalog: " + String(error));
			showNotification({
				message: "Fehler beim Setzen des Standard-Katalogs",
				type: "error",
			});
		}
	},

	setClientDefaultCatalog: async (catalogId: string | null, catalogType: 'default' | 'custom') => {
		const { client } = get();

		if (!client?.id) {
			Logger.error("No client ID when setting default catalog");
			return;
		}

		try {
			const updateData: any = {};

			if (catalogId === null) {
				updateData.default_catalogs_default_id = null;
				updateData.default_catalogs_custom_id = null;
			} else if (catalogType === 'default') {
				updateData.default_catalogs_default_id = catalogId;
				updateData.default_catalogs_custom_id = null;
			} else {
				updateData.default_catalogs_default_id = null;
				updateData.default_catalogs_custom_id = catalogId;
			}

			const { error } = await supabase
				.from(SupabaseWriteTableEnum.CLIENTS)
				.update(updateData)
				.eq("id", client.id);

			if (error) {
				Logger.error("Error setting client default catalog: " + error.message);
				showNotification({
					message: "Fehler beim Setzen des Standard-Katalogs",
					type: "error",
				});
				return;
			}

			set({
				client: {
					...client,
					...updateData
				} as any
			});

			showNotification({
				message: catalogId ? "Standard-Katalog erfolgreich gesetzt" : "Standard-Katalog entfernt",
				type: "success",
			});
		} catch (error) {
			Logger.error("Error setting client default catalog: " + String(error));
			showNotification({
				message: "Fehler beim Setzen des Standard-Katalogs",
				type: "error",
			});
		}
	},
});
